import { withModalProvider } from "../../hoc/withModalProvider";

import { PreviewQuestionsModal as View, IProps } from "./PreviewQuestionsModal";

export const PreviewQuestionsModal = withModalProvider<IProps>(View);
